/**
 * 独立站启动目录查询：复用空间 startup / 订阅接口，不暴露「空间配置」概念。
 */
import { SpaceApi } from "../../platform_spaces/space/SpaceApi";
import type {
  MembershipProduct,
  SpaceModuleConfig,
  UserSubscriptionItem,
} from "../../platform_spaces/space/SpaceType";
import { useLongfansMock } from "../../global/GlobalMock";
import { mockLoadStandaloneCatalog } from "./StandaloneCatalogMock";

export type StandaloneCatalogPayload = {
  modules: MembershipProduct[];
};

function mergeModulesWithSubscriptions(
  modules: SpaceModuleConfig[],
  subs: UserSubscriptionItem[] | null
): MembershipProduct[] {
  if (subs == null || subs.length === 0) {
    return modules.map((m) => ({
      ...m,
      userSubscribed: false,
      daysRemaining: null,
    }));
  }
  const byId = new Map(subs.map((s) => [s.spaceProductId, s]));
  return modules.map((m) => {
    const s = byId.get(m.spaceProductId);
    return {
      ...m,
      userSubscribed: s?.userSubscribed ?? false,
      daysRemaining: s?.daysRemaining ?? null,
    };
  });
}

export const StandaloneCatalogApi = {
  async loadCatalog(spaceId: string): Promise<StandaloneCatalogPayload | string> {
    if (useLongfansMock) {
      return mockLoadStandaloneCatalog(spaceId);
    }
    const [cfgRes, subRes] = await Promise.all([
      SpaceApi.getStartupConfig(spaceId),
      SpaceApi.getSubscriptionDetail(spaceId),
    ]);
    if (typeof cfgRes === "string") {
      return cfgRes;
    }
    const subs = typeof subRes === "string" ? null : subRes;
    return { modules: mergeModulesWithSubscriptions(cfgRes, subs) };
  },
};
